import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import deTranslation from '@/locales/de.json';

const isDevelop = ['development', 'staging'].includes(import.meta.env.VITE_APP_ENV);
const STORAGE_KEY = 'i18nextLng';
const MIGRATION_KEY = 'i18next_migrated_en_to_de';

let initialLang = 'de';

if (isDevelop) {
  if (!localStorage.getItem(MIGRATION_KEY)) {
    if (localStorage.getItem(STORAGE_KEY) === 'en') {
      localStorage.setItem(STORAGE_KEY, 'de');
    }
    localStorage.setItem(MIGRATION_KEY, 'true');
  }
  const savedLang = localStorage.getItem(STORAGE_KEY);

  if (!savedLang) {
    localStorage.setItem(STORAGE_KEY, 'de');
    initialLang = 'de';
  } else {
    initialLang = savedLang.startsWith('de') ? 'de' : 'en';
  }
} else {
  localStorage.setItem(STORAGE_KEY, 'de');
  initialLang = 'de';
}

i18n
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'de',
    supportedLngs: isDevelop ? ['en', 'de'] : ['de'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    resources: {
      de: {
        translation: deTranslation,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    document.documentElement.lang = i18n.language;
  })
  .catch((error) => {
    console.error('Failed to initialize i18n:', error);
  });

if (isDevelop) {
  import('@/locales/en.json')
    .then((enModule) => {
      i18n.addResourceBundle('en', 'translation', enModule.default, true, true);

      if (initialLang === 'en') {
        void i18n.changeLanguage('en');
      }
    })
    .catch((err) => console.error('Failed to load English translations', err));

  i18n.on('languageChanged', (lng) => {
    localStorage.setItem(STORAGE_KEY, lng);

    document.documentElement.lang = lng;
  });
}

export default i18n;
